import { render, staticRenderFns } from "./VaAvatar.vue?vue&type=template&id=9418407e&scoped=true&"
import script from "./VaAvatar.vue?vue&type=script&lang=ts&"
export * from "./VaAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./VaAvatar.vue?vue&type=style&index=0&id=9418407e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9418407e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9418407e')) {
      api.createRecord('9418407e', component.options)
    } else {
      api.reload('9418407e', component.options)
    }
    module.hot.accept("./VaAvatar.vue?vue&type=template&id=9418407e&scoped=true&", function () {
      api.rerender('9418407e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/VaAvatar.vue"
export default component.exports